import {registerAPIService} from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';

const MessageApiServiceBase = class MessageApiServiceBase extends APIServiceBase {
    constructor(endpointControllerName) {
        super(endpointControllerName)
    }

    create(data) {
        return this.post('create', data)
    }

    sendRespond(data) {
        return this.post('SendRespond', data)
    }
}

export default class MessageAPIService extends MessageApiServiceBase {
    constructor() {
        super('Message')
    }
}

registerAPIService(MessageAPIService)